export default ({ className = '', onNav, query = '', text = 'Today' }) => {
  return (
    <Link className={className} to={`/dodones/today${query}`} onClick={onNav}>
      {text}
    </Link>
  )
}
